import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles.css';

export default function AdminHeaderMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div className='adminHeaderMenu'>
      <div className='adminHeaderItem title'>Admin</div>
      <div className={`adminHeaderInner ${open && 'adminHeaderVisible'}`}>

        {config.map((item, index) => {
          if (item.children) {
            return <SubMenu key={index} item={item} />
          } else {
            return <Link key={index} to={item.link}>{item.title}</Link>
          }
        })}
      </div>
      <div>
        <button className='mobileMenuToggle mobileShow' onClick={() => { setOpen(!open) }}>{open ? <i className='fa-solid fa-caret-up'></i> : <i className='fa-solid fa-caret-down'></i>}</button>
      </div>
    </div>)
}

function SubMenu({ item }) {
  const [open, setOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location])

  return (
    <div className='adminHeaderItem'>
      <button onClick={() => { setOpen(!open) }}>{item.title} {open ? <i className='fa-solid fa-caret-up'></i> : <i className='fa-solid fa-caret-down'></i>}</button>
      {open &&
        <div className='adminHeaderSubmenu'>
          {item.children.map((link) => {
            return <div className='adminHeaderSubmenu__item' key={link.title}><Link to={link.link}>{link.title}</Link></div>
          })}
        </div>
      }
    </div>
  )
}




const config = [
  {
    title: 'Home',
    link: '/admin'
  },
  {
    title: 'Orders',
    link: '/admin/orders'
  },
  {
    title: 'Shipments',
    link: '/admin/shipments'
  },
  {
    title: 'Products',
    link: '/admin/products'
  },
  {
    title: 'Publishers',
    link: '/admin/publishers'
  },
  {
    title: 'Curation',
    children: [
      {
        title: 'Blog',
        link: '/admin/posts'
      },
      {
        title: 'Lists',
        link: '/admin/lists'
      },
      {
        title: 'Homepage',
        link: '/tools/homepage'
      },
    ]
  },
  {
    title: 'News',
    link: '/admin/news'
  },
  {
    title: 'Customers',
    link: '/pub/directory'
  },
  {
    title: 'Catalogs',
    link: '/admin/catalogs'
  },
  {
    title: 'Knowledge Base',
    link: '/admin/base'
  },
  {
    title: 'Calendar',
    link: '/admin/calendar'
  },
  {
    title: 'Inventory',
    children: [
      {
        title: 'Inventory Manager',
        link: '/tools/inventory'
      },
      {
        title: 'Inventory Check',
        link: '/tools/inventory-check'
      },
      {
        title: 'Inventory Brain',
        link: '/admin/inventory-brain'
      },
      {
        title: 'Stock Requests',
        link: '/admin/requests'
      },
      {
        title: 'Inventory History',
        link: '/admin/inventory-history'
      },
      {
        title: 'Inventory Explorer',
        link: '/admin/inventory-explorer'
      },
      {
        title: 'Pick History (old)',
        link: '/tools/pick-history'
      },
      {
        title: 'Sales & Inventory Overview (old)',
        link: '/admin/sales'
      },
    ]
  },
  {
    title: 'Tools',
    children: [
      {
        title: 'Picker',
        link: '/tools/picker'
      },
      {
        title: 'Pre-order Dashboard',
        link: '/admin/preorders'
      },
      {
        title: 'Offboarding',
        link: '/admin/offboard'
      },
      {
        title: 'QR Code Generator',
        link: '/tools/qr-code-generator'
      },
      {
        title: 'Shipping Calculator',
        link: '/tools/shipping'
      },
      {
        title: 'Newsletter Helper',
        link: 'https://asterismbooks.com/tools/newsletter-legacy'
      },
      {
        title: 'Label Maker',
        link: '/tools/labels'
      }
    ]
  },
  {
    title: 'Other',
    children: [
      {
        title: 'Shipping Supplies',
        link: '/admin/supplies'
      },
      {
        title: 'Subscriptions',
        link: '/admin/subscriptions'
      }
    ]
  }
]